import type { Payment } from '../types';

// Modos de vista del kanban de pagos (regla 2026-06: ya no hay mínimo
// de pago — el recálculo crea card para todo collector con ≥ $3).
//   'top': solo los de $100 o más (meets_minimum) — total a pagar grande.
//   'all': todos los que pueden cobrar — wallet configurada y ≥ $3.
export type PaymentMode = 'top' | 'all';

export const PAYMENT_MODE_OPTIONS: { value: PaymentMode; label: string }[] = [
  { value: 'top', label: '+$100' },
  { value: 'all', label: 'Completo' },
];

export function filterPendingByMode(
  items: Payment[],
  mode: PaymentMode
): Payment[] {
  if (mode === 'top') return items.filter((p) => p.meets_minimum);
  return items.filter((p) => !!p.usdc_wallet && p.total_earnings >= 3);
}
